import { Capacitor, registerPlugin } from "@capacitor/core";

export interface MetaAttributionContext {
  enabled: boolean;
  anonymousId?: string;
  appId?: string;
  attStatus: "authorized" | "denied" | "restricted" | "notDetermined" | "unknown";
}

const MetaAppEvents = registerPlugin<{
  syncTrackingStatus(): Promise<void>;
  getAttributionContext(): Promise<MetaAttributionContext>;
}>("MetaAppEvents");

/** Missing methods in older binaries are expected while the remote website rolls out. */
export async function getMetaAttributionContext(): Promise<MetaAttributionContext | null> {
  try {
    if (Capacitor.getPlatform() !== "ios" || !Capacitor.isPluginAvailable("MetaAppEvents"))
      return null;
    const context = await MetaAppEvents.getAttributionContext();
    if (!context.enabled || !context.anonymousId?.trim()) return null;
    return context;
  } catch {
    return null;
  }
}

/** Native code owns consent and activation. This also tolerates older installed binaries. */
export async function syncMetaTrackingStatus(): Promise<void> {
  try {
    if (Capacitor.getPlatform() !== "ios" || !Capacitor.isPluginAvailable("MetaAppEvents")) return;
    await MetaAppEvents.syncTrackingStatus();
  } catch {
    console.warn("[Meta] Could not synchronize tracking permission");
  }
}
